import { render, staticRenderFns } from "./QRenewedTextArea.vue?vue&type=template&id=f906cde4&scoped=true&"
import script from "./QRenewedTextArea.vue?vue&type=script&lang=js&"
export * from "./QRenewedTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f906cde4",
  null
  
)

export default component.exports